import React from 'react';
import { Users, Mail, MapPin, Phone, ChevronRight } from 'lucide-react';
export function ClubCard() {
  return <div className="bg-white rounded-2xl p-6 h-full flex flex-col" style={{
    boxShadow: '0 4px 24px rgba(0,0,0,0.07)'
  }} data-id="element-1">
      {/* Header */}
      <div className="flex items-center gap-3 mb-5" data-id="element-2">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{
        backgroundColor: '#eff8ff'
      }} data-id="element-3">
          <Users className="w-5 h-5" style={{
          color: '#3b8fd4'
        }} data-id="element-4" />
        </div>
        <div data-id="element-5">
          <h3 className="font-semibold text-slate-800 text-base" data-id="element-6">
            Мій осередок
          </h3>
          <p className="text-xs text-slate-400" data-id="element-7">Контакти представників</p>
        </div>
      </div>

      {/* Representatives info */}
      <div className="flex flex-col gap-4 flex-1" data-id="element-8">
        {/* Club Representative */}
        <div className="flex flex-col gap-2.5" data-id="element-9">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide" data-id="element-10">
            Представник клубу
          </p>
          <div className="flex items-center gap-3" data-id="element-11">
            <div className="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-semibold flex-shrink-0" style={{
            background: 'linear-gradient(135deg, #3b8fd4, #1d6fa8)'
          }} data-id="element-12">
              ОК
            </div>
            <div data-id="element-13">
              <p className="text-sm font-semibold text-slate-700" data-id="element-14">
                Олена Коваленко
              </p>
              <p className="text-xs text-slate-400" data-id="element-15">Менеджер СК "Вертикаль"</p>
            </div>
          </div>

          <div className="flex items-center gap-2.5 p-2.5 rounded-lg" style={{
          backgroundColor: '#f8fafc'
        }} data-id="element-16">
            <Mail className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" data-id="element-17" />
            <span className="text-xs text-slate-600 truncate" data-id="element-18">
              manager@vertikalclub.ua
            </span>
          </div>
          <div className="flex items-center gap-2.5 p-2.5 rounded-lg" style={{
          backgroundColor: '#f8fafc'
        }} data-id="element-19">
            <Phone className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" data-id="element-20" />
            <span className="text-xs text-slate-600" data-id="element-21">+38 (057) 123-45-67</span>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-100" data-id="element-22" />

        {/* Regional Representative */}
        <div className="flex flex-col gap-2.5" data-id="element-23">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide" data-id="element-24">
            Представник регіону
          </p>
          <div className="flex items-center gap-3" data-id="element-25">
            <div className="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-semibold flex-shrink-0" style={{
            background: 'linear-gradient(135deg, #3b8fd4, #1d6fa8)'
          }} data-id="element-26">
              ІП
            </div>
            <div data-id="element-27">
              <p className="text-sm font-semibold text-slate-700" data-id="element-28">
                Іван Петренко
              </p>
              <p className="text-xs text-slate-400" data-id="element-29">
                Координатор Харківської області
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2.5 p-2.5 rounded-lg" style={{
          backgroundColor: '#f8fafc'
        }} data-id="element-30">
            <Mail className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" data-id="element-31" />
            <span className="text-xs text-slate-600 truncate" data-id="element-32">
              kharkiv@fais.org.ua
            </span>
          </div>
          <div className="flex items-center gap-2.5 p-2.5 rounded-lg" style={{
          backgroundColor: '#f8fafc'
        }} data-id="element-33">
            <Phone className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" data-id="element-34" />
            <span className="text-xs text-slate-600" data-id="element-35">+38 (057) 111-22-33</span>
          </div>
        </div>
      </div>
    </div>;
}